// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6s1nB","tabsBox":"styles_tabsBox__3KBWL","createButton":"styles_createButton__1vpIy"};